module.exports = __webpack_public_path__ + "assets/img/zk.384ed80d.png";